import { render } from "./PhoneDialog.vue?vue&type=template&id=6b600bf0&scoped=true"
import script from "./PhoneDialog.vue?vue&type=script&lang=js"
export * from "./PhoneDialog.vue?vue&type=script&lang=js"

import "./PhoneDialog.vue?vue&type=style&index=0&id=6b600bf0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b600bf0"]])

export default __exports__